import React, { useEffect, useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col
} from "reactstrap";
import {format} from 'date-fns';

const AccountInformation = (props) => {
    const credential = props.credential
    const formDisabled = props.formDisabled
    const[status, setStatus] = useState()

    useEffect(()=>{
        let label = "Pending"
        
        if(credential?.user?.accountConfirmation==true)
            label= "Enable"
        
        setStatus(label)

    }, [credential.pending])

    let formatDate = () => {
        let date = '' 

        if(credential && credential.date)
            date = format(credential.date, "yyyy-MM-dd")
        
        return date
    }   

    return (
        <>
            <hr className="my-4" />

            <h6 className="heading-small text-muted mb-4">Account Information</h6>
            <div className="pl-lg-4">
                <Row>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-creation"
                            >
                                Creation Date
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-creation"
                                defaultValue={formatDate()}
                                type="date"
                                disabled={formDisabled}
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-status"
                            >
                                Status
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-status"
                                defaultValue={status}
                                type="text"
                                disabled={formDisabled}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default AccountInformation